import React, { useState } from 'react';
import './ComingSoon.css';

function ComingSoon() {
  const [email, setEmail] = useState('');
  const [userType, setUserType] = useState('job_seeker');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    // Store in localStorage as fallback — replace with API call when ready
    const waitlist = JSON.parse(localStorage.getItem('waitlist') || '[]');
    waitlist.push({ email, userType, date: new Date().toISOString() });
    localStorage.setItem('waitlist', JSON.stringify(waitlist));
    setTimeout(() => {
      setSubmitted(true);
      setLoading(false);
    }, 600);
  };

  return (
    <div className="cs-page">
      {/* Background blobs */}
      <div className="cs-blob cs-blob-1" />
      <div className="cs-blob cs-blob-2" />
      <div className="cs-blob cs-blob-3" />

      {/* Floating particles */}
      <div className="cs-particles">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="cs-particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDuration: `${4 + Math.random() * 6}s`,
              animationDelay: `${Math.random() * 5}s`,
              width: `${2 + Math.random() * 4}px`,
              height: `${2 + Math.random() * 4}px`,
              background: i % 3 === 0 ? 'rgba(99,102,241,0.7)' : i % 3 === 1 ? 'rgba(139,92,246,0.7)' : 'rgba(6,182,212,0.5)',
            }}
          />
        ))}
      </div>

      <div className="cs-card">
        {/* Logo */}
        <div className="cs-logo">
          <img src="/JobLinkedAI.png" alt="JobLinked AI" />
          <span>JobLinked AI</span>
        </div>

        {/* Badge */}
        <div className="cs-badge">🚀 Launching Soon</div>

        {/* Headline */}
        <h1 className="cs-title">
          AI-Powered Job Matching<br />
          <span>Built for South Africa</span>
        </h1>

        <p className="cs-subtitle">
          Connect directly with top SA recruiters. Let AI match your CV to the right jobs,
          auto-apply while you sleep, and track every application in one place.
        </p>

        {/* Features */}
        <div className="cs-features">
          <div className="cs-feature">
            <span className="cs-feature-icon">🤖</span>
            <span>AI Job Matching</span>
          </div>
          <div className="cs-feature">
            <span className="cs-feature-icon">⚡</span>
            <span>Auto-Apply</span>
          </div>
          <div className="cs-feature">
            <span className="cs-feature-icon">📊</span>
            <span>Application Tracking</span>
          </div>
          <div className="cs-feature">
            <span className="cs-feature-icon">🏢</span>
            <span>Direct from Recruiters</span>
          </div>
        </div>

        {/* Waitlist form */}
        {!submitted ? (
          <form className="cs-form" onSubmit={handleSubmit}>
            <p className="cs-form-label">Get early access — be first to know when we launch:</p>

            <div className="cs-toggle">
              <button
                type="button"
                className={userType === 'job_seeker' ? 'active' : ''}
                onClick={() => setUserType('job_seeker')}
              >
                👤 Job Seeker
              </button>
              <button
                type="button"
                className={userType === 'recruiter' ? 'active' : ''}
                onClick={() => setUserType('recruiter')}
              >
                🏢 Recruiter
              </button>
            </div>

            <div className="cs-input-row">
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <button type="submit" disabled={loading}>
                {loading ? '...' : 'Notify Me'}
              </button>
            </div>
            <p className="cs-privacy">No spam. Unsubscribe anytime.</p>
          </form>
        ) : (
          <div className="cs-success">
            <div className="cs-success-icon">✅</div>
            <h3>You're on the list!</h3>
            <p>We'll notify you at <strong>{email}</strong> when JobLinked AI launches.</p>
          </div>
        )}

        {/* Footer */}
        <div className="cs-footer">
          <p>Built with ❤️ in South Africa</p>
          <div className="cs-footer-links">
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
            <a href="mailto:hello@joblinkedai.co.za">Contact</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
